import * as React from 'react';
import PropTypes from 'prop-types';
import { Grid, CircularProgress, Typography } from '@material-ui/core';
import { FLIGHT_MESSAGES } from './flightMessages';

// Show the real contextual message first. If the same message has been on screen
// for longer than this, the wait is long enough to be worth a little fun.
const ROTATE_AFTER_MS = 4000;
// Once we start rotating clever messages, swap to a new one this often.
const ROTATE_EVERY_MS = 4000;

const DEFAULT_MSG = 'Loading ...';

// Pick a random flight message, avoiding an immediate repeat of `prev`.
const pickFlightMessage = (prev) => {
  if (!FLIGHT_MESSAGES.length) return prev;
  if (FLIGHT_MESSAGES.length === 1) return FLIGHT_MESSAGES[0];
  let next = prev;
  while (next === prev) {
    next = FLIGHT_MESSAGES[Math.floor(Math.random() * FLIGHT_MESSAGES.length)];
  }
  return next;
};

// Shared spinner used everywhere. Pass `msg` for context (e.g. "Loading Flight
// Plan ..."). On long waits it keeps the user company with rotating flight-themed
// messages, resetting to the real message whenever `msg` changes. Set
// `rotate={false}` to keep a plain static spinner.
const LoadingCircle = ({ classes, msg, rotate = true }) => {
  const baseMsg = msg || DEFAULT_MSG;
  const [display, setDisplay] = React.useState(baseMsg);

  React.useEffect(() => {
    // A new real message just arrived (or first render): show it immediately.
    setDisplay(baseMsg);
    if (!rotate) return undefined;

    let intervalId;
    const startId = setTimeout(() => {
      setDisplay((prev) => pickFlightMessage(prev));
      intervalId = setInterval(() => {
        setDisplay((prev) => pickFlightMessage(prev));
      }, ROTATE_EVERY_MS);
    }, ROTATE_AFTER_MS);

    return () => {
      clearTimeout(startId);
      if (intervalId) clearInterval(intervalId);
    };
  }, [baseMsg, rotate]);

  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <CircularProgress className={classes.progress} />
      {display && <Typography style={{ marginTop: '12px' }}>{display}</Typography>}
    </Grid>
  );
};
LoadingCircle.propTypes = {
  classes: PropTypes.any,
  msg: PropTypes.string,
  rotate: PropTypes.bool,
};

export default LoadingCircle;
